import { useParams } from 'react-router-dom';

import { BreadcrumbItem, Link } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

export const OverviewBreadcrumbItem = () => {
  const { t } = useTranslation();
  const { tenantId } = useParams() ?? {};

  return (
    <BreadcrumbItem className="hidden sm:block">
      <Link to={`/organizations/${tenantId}/home`}>
        {t('sidebar.overview')}
      </Link>
    </BreadcrumbItem>
  );
};
